if (!customElements.get('cart-bundle-upsell')) {
  customElements.define(
    'cart-bundle-upsell',
    class CartBundleUpsell extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.cart-drawer-upsell__add-button');
        this.button?.addEventListener('click', this.handleAdd.bind(this));
      }

      async handleAdd() {
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const variantId = parseInt(this.dataset.variantId, 10);
        const removeKeys = JSON.parse(this.dataset.removeKeys || '[]');
        const cartDrawer = document.querySelector('cart-drawer');
        const sections = cartDrawer
          ? cartDrawer.getSectionsToRender().map((section) => section.id)
          : [];

        try {
          // Step 1: Remove qualifying individual items
          if (removeKeys.length > 0) {
            const updates = {};
            removeKeys.forEach((key) => (updates[key] = 0));
            await fetch(routes.cart_update_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates }),
            });
          }

          // Step 2: Add the bundle and get updated sections
          const response = await fetch(routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              sections: sections,
              sections_url: window.location.pathname,
            }),
          });

          const data = await response.json();

          if (data.status) {
            this.resetButton();
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-bundle-upsell',
            cartData: data,
          });

          if (cartDrawer) {
            cartDrawer.renderContents(data);
          }
        } catch (e) {
          console.error('Bundle upsell error:', e);
          this.resetButton();
        }
      }

      resetButton() {
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('loading');
        this.querySelector('.loading__spinner')?.classList.add('hidden');
      }
    }
  );
}
